import { createContext, useContext } from 'react';
import { type SampleNamesTableContext } from './SampleNames.model';

export const sampleNamesTableContext = createContext<SampleNamesTableContext | undefined>(undefined);

export const useSampleNamesTableContext = (): SampleNamesTableContext => {
  const ctx = useContext(sampleNamesTableContext);
  if (ctx === undefined) {
    throw new Error('useSampleNamesTableContext must be used inside SampleNamesTableProvider');
  }
  return ctx;
};
